export default {

    /**
     * チャートのインストール
     * (今後、外部にJSに移動しても問題なく動くように本体とは疎結合にする)
     * @param vue
     * @param opts
     */
    install(vue,opts = {}){
        vue.component('chart-ball-position-home', () => import('./js/ChartBallPositionHome.vue'))
        vue.component('chart-inning-range', () => import('./js/ChartInningRange.vue'))
        vue.component('chart-series-line', () => import('./js/ChartSeriesLine.vue'))

        vue.component('chart-pie', () => import('./js/ChartPie.vue'))
        vue.component('chart-batting-zone', () => import('./js/ChartBattingZone.vue'))
        vue.component('chart-batting-angle', () => import('./js/ChartBattingAngle.vue'))
        vue.component('chart-batting-stadium', () => import('./js/ChartBattingStadium.vue'))

        vue.component('chart-legend', () => import('./js/ChartLegend.vue'))
    }
}
D3Chart.Logger.setup({
    debug: function (name) {
        return function (...args) {
            // console.log(`[${name}] DEBUG`, ...args);
        }
    }
})
